import PointerEvents from '../../../vendor_core/core/src/const/PointerEvents';
import BetModel from '../../../vendor_core/core/src/model/BetModel';
import GameModel from '../../../vendor_core/core/src/model/GameModel';
import { State } from '../../../vendor_core/core/src/states/State';
import { DefaultLayers } from '../../../vendor_core/core/src/utils/Layers';
import Locale from '../../../vendor_core/core/src/utils/Locale';
import ViewManager from '../../../vendor_core/core/src/utils/ViewManager';

export default class BBInsufficientBalanceState extends State {
    enter() {
        super.enter();
        ViewManager.getLayer("PopupsBackground").setScene("open");
        let popup = ViewManager.getLayer(DefaultLayers.Popups).setScene(
            "message_box"
        );
        const title = popup.sceneTextFields.get("title");
        title.text = " ";
        const message = popup.sceneTextFields.get("text");
        message.text = Locale.getString("insufficient_funds");
        const button = popup.buttons.get("exit");
        button.once(PointerEvents.DOWN, () => {
            if(BetModel.getMaxPossibleBet() == 0) {
                GameModel.shouldStopAutoplay = true;  // to stop auto spin loop when there is no money
            }
            ViewManager.getLayer(DefaultLayers.Popups).clear();
            BetModel.insufficientBalance = false;
            this.exit();
        });
    }

    public exit(): void {
        super.exit();
        ViewManager.getLayer("PopupsBackground").clear();
    }
}
